import type { FullShipment } from '@fv/client-types'

import { DetailPanelLayout } from '@/components/list/DetailPanelLayout'

import { useShareShipmentForm } from './mutations'
import ShareForm from './ShareForm'
import SharePanelHeader from './SharePanelHeader'
import { SharePanelMain } from './SharePanelMain'

type SharePanelProps = {
  closePanel: () => void
  load: Pick<FullShipment, 'documents' | 'loadId' | 'shares' | 'workflow'>
}

export const SharePanel = ({ closePanel, load }: SharePanelProps) => {
  const { loadId, documents = [], shares = [] } = load
  const form = useShareShipmentForm({
    loadId,
    documents,
  })

  return (
    <DetailPanelLayout
      header={<SharePanelHeader closePanel={closePanel} />}
      footer={
        <ShareForm
          form={form}
          shareShipment={emails => {
            form.submitShare(emails, {
              onSuccess: closePanel,
            })
          }}
        />
      }
    >
      <SharePanelMain
        className="overflow-auto"
        workflow={load.workflow}
        shares={shares}
        form={form}
      />
    </DetailPanelLayout>
  )
}
